import styled, { css } from 'styled-components/macro';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
export const FlexWrapperStyled = styled(FlexWrapper) `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};

  ${({ isVerticalIndentDefault = true }) => isVerticalIndentDefault &&
    css `
      padding-top: 24px;
      padding-bottom: 24px;

      ${ADAPTIVE.minWidth.tablet} {
        padding-top: 32px;
        padding-bottom: 32px;
      }

      ${ADAPTIVE.minWidth.desktop} {
        padding-top: 40px;
        padding-bottom: 48px;
      }
    `}
`;
